<template>
  <lazy-div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <quick-info-query></quick-info-query>
        </v-flex>
        <v-flex xl6 xs12>
          <v-layout row wrap>
            <v-flex xs12>
              <premium></premium>
            </v-flex>
            <v-flex xs12>
              <applicant></applicant>
            </v-flex>
            <v-flex xs12>
              <risk-info></risk-info>
            </v-flex>
            <v-flex xs12>
              <payment></payment>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xl6 xs12>
          <plan-info></plan-info>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <comments query></comments>
        </v-flex>
      </v-layout>
    </v-container>
  </lazy-div>
</template>

<script>
import { quoteStatus } from '@/const/underwriting'
import QuickInfoQuery from './QuickInfoQuery'
import Premium from './Premium'
import Applicant from './Applicant'
import RiskInfo from './RiskInfo'
import Payment from './Payment'
import PlanInfo from './PlanInfo'
import Comments from '../../shared/Comments'

export default {
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    currentStatus() {
      return quoteStatus[this.$store.state.agency.quotation.commonInfo.statusCode]
    }
  },
  methods: {
    async doInit() {
      try {
        const dispatchObj = {
          proposalNo: this.id,
          query: true
        }
        await this.$store.dispatch('loadQuote', dispatchObj)
      } catch (err) {
        throw err
      }
    }
  },
  props: [
    'id'
  ],
  components: {
    QuickInfoQuery,
    Premium,
    Applicant,
    RiskInfo,
    Payment,
    PlanInfo,
    Comments
  }
}
</script>

<style>
</style>
